export enum ScrollTargetSelector {
  Customizer = '#customizer',
  Form = '.jbr-form',
}
